export const DEFAULT_PARAMS_ORDER = {
	by: "",
	dir: "",
};
export const DEFAULT_PARAMS_PAGE = 1;
export const MAX_LIMIT_BY_PAGE = 25;

